import {BaseVueEntity} from "@/entities/BaseVueEntity";
import {isDefined} from "@/utils";

export class Speaker extends BaseVueEntity {

  private readonly _id: string;
  private readonly _firstName: string;
  private readonly _lastName: string;
  private readonly _title: string;
  private readonly _picture: string;
  private readonly _info: string;
  private readonly _displayName: string;
  private readonly _picturePath: string;
  private readonly _company: string;
  private readonly _position: string;
  private readonly _sortOrder: string;
  private readonly _country: string;

  constructor(entity, picturePath) {
    super();
    this._id = entity.ID;
    this._firstName = entity.VORNAME;
    this._lastName = entity.NACHNAME;
    this._picture = entity.BILD;
    this._title = entity.TITLE;
    this._info = entity.INFO;
    this._displayName = entity.ANZEIGENAME;
    this._company = entity.FIRMA;
    this._position = entity.POSITION;
    this._sortOrder = entity.S_ORDER;
    this._country = entity.LAND;
    this._picturePath = picturePath;
  }

  public hasPicture(): boolean {
    return isDefined(this._picture);
  }

  public getPictureUrl(): string {
    return process.env.VUE_APP_BACKEND_URL + '/' + this._picturePath + this._picture;
  }

  public hasSearchValue(value: string): boolean {
    for (const prop of ['_displayName', '_company','_info']) {
      if (isDefined(this[prop]) && this[prop].toLowerCase().indexOf(value) > -1) {
        return true;
      }
    }
    return false;
  }


  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get picture(): string {
    return this._picture;
  }

  get picturePath(): string {
    return this._picturePath;
  }


  get title(): string {
    return this._title;
  }

  get info(): string {
    return this._info;
  }

  get displayName(): string {
    return this._displayName;
  }

  get company(): string {
    return this._company;
  }


  get position(): string {
    return this._position;
  }


  get id(): string {
    return this._id;
  }


  get sortOrder(): string {
    return this._sortOrder;
  }

  get country(): string {
    return this._country;
  }
}
